export default {
  calendarMeeting: [],
};
